export default __webpack_public_path__ + "static/media/PER.515abbbd.svg";